<template>
	<fixed :side="side">
		<options-button v-bind="$props" v-on="$listeners">
      <slot></slot>
    </options-button>
	</fixed>
</template>

<script>
export default {
	props: ['icon', 'side', 'color', 'title', 'id'],
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/FloatOptionsButton.vue